export var resolveMd5BodyChecksumConfig = function (input) { return input; };
